import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';

export enum FeedbackState {
  NONE = 'NONE',
  HELPFUL = 'HELPFUL',
  NOT_HELPFUL = 'NOT_HELPFUL',
}

interface SQLAssistantFeedbackProps {
  usefulFeedbackState: FeedbackState;
  setUsefulFeedbackState: (state: FeedbackState) => void;
  openFeedbackModal: () => void;
  traceId: string;
}

export default function SQLAssistantFeedback(props: SQLAssistantFeedbackProps): JSX.Element {
  const {usefulFeedbackState, setUsefulFeedbackState, openFeedbackModal, traceId} = props;

  return (
    <div
      className={css(styles.thumbsContainer)}
      data-test-component="SQLAssistantFeedback"
      data-test-element="root"
    >
      <span>Was this helpful?</span>
      {usefulFeedbackState !== FeedbackState.NOT_HELPFUL && (
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          onClick={() => {
            trackEvent(INSIGHTS_ANALYTICS_ACTIONS.SUBMITTED_SQL_AI_ASSISTANT_SUGGESTION_USEFULNESS, {
              traceId,
              useful_feedback_state: true,
            });
            setUsefulFeedbackState(FeedbackState.HELPFUL);
          }}
          disabled={usefulFeedbackState !== FeedbackState.NONE}
          className={classNames(usefulFeedbackState === FeedbackState.HELPFUL && css(styles.selectedThumb))}
        >
          <span className="fa fa-thumbs-up" />
        </Button>
      )}
      {usefulFeedbackState !== FeedbackState.HELPFUL && (
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          onClick={() => {
            trackEvent(INSIGHTS_ANALYTICS_ACTIONS.SUBMITTED_SQL_AI_ASSISTANT_SUGGESTION_USEFULNESS, {
              traceId,
              useful_feedback_state: false,
            });
            setUsefulFeedbackState(FeedbackState.NOT_HELPFUL);
          }}
          disabled={usefulFeedbackState !== FeedbackState.NONE}
          className={classNames(
            usefulFeedbackState === FeedbackState.NOT_HELPFUL && css(styles.selectedThumb)
          )}
        >
          <span className="fa fa-thumbs-down" />
        </Button>
      )}
      {usefulFeedbackState !== FeedbackState.NONE && (
        <a
          role="button"
          tabIndex={0}
          onClick={openFeedbackModal}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              openFeedbackModal();
            }
          }}
        >
          Tell us more
        </a>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  selectedThumb: {
    color: Colors.NEAR_BLACK,
  },
  thumbsContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 4,
  },
});
